import { request } from './request'

export const getCustomerList = (data) => {
  const url = '/ocean/api/v1/shop/merchant-customer/list'
  return request({
    method: 'post',
    url: url,
    data
  })
}

export const addCustomer = (data) => {
  const url = '/ocean/api/v1/shop/merchant-customer'
  return request({
    method: 'post',
    url: url,
    data
  })
}

export const editCustomer = (data) => {
  const url = `/ocean/api/v1/shop/merchant-customer/${data.id}`
  return request({
    method: 'put',
    url: url,
    data
  })
}

export const getCustomerDetail = (id) => {
  const url = `/ocean/api/v1/shop/merchant-customer/${id}/detail`
  return request({
    method: 'get',
    url: url,
  })
}

export const getCustomerHistory = (params) => {
  const url = `/ocean/api/v1/shop/merchant-customer/${params.id}/history-orders`
  return request({
    method: 'get',
    url: url,
    params
  })
}

export const batchSetTag = (data) => {
  const url = '/ocean/api/v1/shop/merchant-customer/setTag'
  return request({
    method: 'put',
    url: url,
    data
  })
}

export const getCustomerAddress = (id) => {
  const url = `/ocean/api/v1/shop/merchant-customer/${id}/customer-addresses`
  return request({
    method: 'get',
    url: url,
  })
}

export const setDefaultAddress = (addressId, tag) => {
  const url = `/ocean/api/v1/shop/merchant-customer/customer-addresses/${addressId}/${tag}`
  return request({
    method: 'put',
    url: url,
  })
}

//获取营销通知列表
export const getEmailList = data => {
  const url = '/ocean/api/v1/cs/customerEmail/get/marketing/list'
  return request({
    method: 'post',
    url: url,
    data
  })
}

// 获取营销通知详情
export const getEmailDetail = params => {
  const url = `/ocean/api/v1/cs/customerEmail/detail`
  return request({
    method: 'get',
    url: url,
    params
  })
}

// 新增营销通知详情
export const addEmailModule = data => {
  const url = '/ocean/api/v1/cs/customerEmail/save'
  return request({
    method: 'post',
    url: url,
    data
  })
}

// 编辑存草稿
export const updateEmailModule = data => {
  const url = `/ocean/api/v1/cs/customerEmail/update/marketing`
  return request({
    method: 'post',
    url: url,
    data
  })
}

// 编辑发送
export const updateSendEmailModule = data => {
  const url = `/ocean/api/v1/cs/customerEmail/send/email`
  return request({
    method: 'post',
    url: url,
    data
  })
}

// 获取发送邮箱列表
export const getSendEmailList = params => {
  const url = `/ocean/api/v1/cs/account/no/page/list`
  return request({
    method: 'get',
    url: url,
    params
  })
}

// 获取订阅者人数，类别
export const getSendCountAndType = params => {
  const url = `/ocean/api/v1/cs/customerEmail/get/account`
  return request({
    method: 'get',
    url: url,
    params
  })
}
